export default __webpack_public_path__ + "static/media/img2.ae5b1469.png";